<template>
    <gc-modal condition="true" @cancel="$emit('cancel')"
              modal-class="gc-modal--wide" body-class="gc-modal__body--scrollable">

        <template slot="messageTitle">
            About
        </template>

        <template slot="body">
            <p class="pre-wrap">{{this.modalParams.about}}</p>
        </template>

        <template slot="footer">
            <button class="btn btnRed" @click.prevent="$emit('cancel')">OK</button>
        </template>
    </gc-modal>
</template>
<script>
    export default {
        name: 'AboutModal',
        props: ['modalParams']
    }
</script>
